<template>
  <v-app>
    <v-content :class="$style.bgContainer">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    //
  }),
};
</script>

<style lang="scss" module>
  @import "styles/base";
  .bgContainer {
    width: 100%;
    min-height: 100vh;
    background-image: url('@/assets/img/Cover_bg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
</style>
